import React, { createContext, useContext, useMemo } from 'react';
import { useConfig } from '../hooks/useConfig';
export var DirectionContext = createContext(undefined);
export var DirectionProvider = function DirectionProvider(props) {
  var direction = props.direction,
      children = props.children;
  var config = useMemo(function () {
    return {
      direction: direction
    };
  }, [direction]);
  return React.createElement(DirectionContext.Provider, {
    value: config
  }, children);
};
export function useDirection() {
  var _useConfig = useConfig(),
      configDirection = _useConfig.direction,
      localeDirection = _useConfig.locale.direction;

  var _ref = useContext(DirectionContext) || {},
      direction = _ref.direction;

  return direction || configDirection || localeDirection || 'ltr';
}